import PropTypes from 'prop-types';

export const AccountPropTypes = PropTypes.shape({
  createdSSO: PropTypes.string,
  glAccount: PropTypes.string.isRequired,
  bsmAccount: PropTypes.string.isRequired,
  periodName: PropTypes.string.isRequired,
  updatedSSO: PropTypes.string,
});

export const AccountMapPropTypes = PropTypes.arrayOf(AccountPropTypes);

export const ModalPropTypes = PropTypes.shape({
  show: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    glAccount: PropTypes.string.isRequired,
  }),
});

export const MapNamePropTypes = PropTypes.shape({
  value: PropTypes.string.isRequired,
});

export const MapNamesPropTypes = PropTypes.arrayOf(MapNamePropTypes);
